export const getDisplayValue = (value, fallback = "N/A") => {
  if (value === null || value === undefined || value === "") {
    return fallback;
  }

  if (Array.isArray(value)) {
    const displayValues = value
      .map((item) => getDisplayValue(item, ""))
      .filter(Boolean);
    return displayValues.length ? displayValues.join(", ") : fallback;
  }

  if (typeof value === "object") {
    return (
      value.universityName ||
      value.name ||
      value.title ||
      value.abbreviation ||
      value.label ||
      fallback
    );
  }

  return value;
};
